// 定义state

const State = {};

export default State;
